export default __webpack_public_path__ + "static/media/Green0005.4d3df09a.png";